import React from 'react';

import { FORMS } from '../../schemas/stepMap';
import InvestmentCriteriaOverview from '../../components/property-summaries/InvestmentCriteriaOverview';

export default function RehabInvestmentCriteria({
  propertyData = {},
  scenarioData = {},
}) {
  const combined = { ...propertyData, ...scenarioData };
  const { rehabWorksheetSubmitted } = combined || {};

  return (
    <InvestmentCriteriaOverview
      schema={FORMS.BuyAndHoldAnalysis.investmentMetrics}
      data={combined}
      type="overview"
      disabled={!rehabWorksheetSubmitted}
    />
  );
}
